<template>
  <div :class="['input-dropdown-wrapper', wrapperClasses]" v-click-out="closeDropdown">
    <div class="display-input-wrapper" @click="toggleDropdown">
      <div :class="['display-input', isOpen ? 'up-arrow' : 'down-arrow', { placeholder: !displayText}]">
        {{displayText || placeholder}}
      </div>
    </div>
    <div :class="['options-wrapper', isOpen ? 'slide-down' : 'slide-up']">
      <div v-if="showDivider" class="divider"></div>
      <loading-icon v-if="isLoading"></loading-icon>
      <div v-else-if="loadingError" class="error-message">{{loadingError}}</div>
      <div v-else class="dropdown-container">
        <search-bar
            v-if="showSearch"
            :searchTerm="searchText"
            @clearSearch="clearSearch"
            @getSearchResult="delaySearchGroup">
        </search-bar>

        <div class="dropdown-options-container">
          <label
              v-for="(option, index) in dropdownOptions"
              :key="option.id"
              class="dropdown-option">
            <input
                v-show="showCheckboxes"
                :id="option.tag || index"
                type="checkbox"
                :value="option.tag ? option.tag : index"
                v-model="selectedOptions"
                @change="updateSelection(option, index)">
            <span v-show="showCheckboxes" class="checkmark"></span>
            <span class="label-name">{{option.name || option}}</span>
          </label>
        </div>
        <div v-if="showPagination">
          <pagination v-show="pagination.current_page && !isLoading"
                      :pagination="pagination"
                      showArrows
                      @changePage="changePage">
          </pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoadingIcon from '../shared/LoadingIcon'
  import Pagination from '../shared/Pagination'
  import SearchBar from '../shared/SearchBar'

  export default {
    props: {
      currentSelection: [String, Object],
      dropdownOptions: Array,
      dropdownType: String,
      isLoading: Boolean,
      isParent: Boolean,
      isSingleSelection: Boolean,
      loadingError: String,
      pagination: Object,
      parentType: String,
      placeholder: String,
      searchError: String,
      searchText: String,
      showDivider: Boolean,
      showCheckboxes: Boolean,
      showPagination: Boolean,
      showSearch: Boolean,
      wrapperClasses: String,
    },

    name: 'InputDropdown',

    components: {
      LoadingIcon,
      Pagination,
      SearchBar,
    },

    data() {
      return {
        displayText: null,
        isOpen: false,
        searchTerm: null,
        selectedOptions: [],
      }
    },

    methods: {
      changePage(page) {
        this.$emit('changePage', page)
      },

      clearSearch() {
        this.searchTerm = null
        this.$emit('clearSearch')
      },

      closeDropdown() {
        this.isOpen = false
      },

      delaySearchGroup(text) {
        this.searchTerm = text
        this.$emit('delaySearchGroup', this.searchTerm)
      },

      setDisplayText(option) {
        let text = this.isGroupType || this.isParent ? option.name : option
        this.displayText = text && text.length > 26 ? `${text.substring(0,26)}...` : text
      },

      setSelectedOptions() {
        if (this.isSingleSelection && this.isGroupType) { this.selectedOptions = [this.currentSelection.tag] }
      },

      toggleDropdown() {
        this.isOpen = !this.isOpen
      },

      updateSelection(option, index) {
        const isDayType = this.dropdownType === 'days',
            value = isDayType ? index : option

        if (this.isSingleSelection) {
          this.isOpen = false
          this.setDisplayText(option)
          this.selectedOptions = [option.tag]
          this.$emit('updateSelection', value)
        }
        if (this.searchTerm) { this.clearSearch() }
      },
    },

    created() {
      this.searchTerm = this.searchText
      if (this.currentSelection) {
        this.setDisplayText(this.currentSelection)
        this.setSelectedOptions()
      }
    },

    computed: {
      isGroupType: function() {
        return this.dropdownType === 'groups'
      }
    },

    watch: {
      currentSelection: function() {
        if (this.currentSelection) { this.setDisplayText(this.currentSelection) }
      },

      parentType: function() {
        this.displayText = null
      },
    },

    directives: {
      clickOut: {
        // from https://jsfiddle.net/bq8m4fhe/
        bind: function(el, binding, vnode) {
          el.clickOutsideEvent = function(event) {
            const isClickOutside = event.target !== el && !el.contains(event.target)
            if (isClickOutside) { vnode.context[binding.expression](event, el.id) }
          }
          document.body.addEventListener("click", el.clickOutsideEvent)
          document.body.addEventListener("touchstart", el.clickOutsideEvent)
        },
        unbind: function(el) {
          document.body.removeEventListener("click", el.clickOutsideEvent);
          document.body.removeEventListener("touchstart", el.clickOutsideEvent);
        },
        stopProp(event) {
          event.stopPropagation();
        }
      }
    },
  }
</script>
